/* ============================================
   TERRAPARTES — Shopify Theme JavaScript
   v0.1.3
   ============================================ */

(function() {
  'use strict';

  /* ---------- WhatsApp URL helpers ---------- */
  function getWhatsAppURL(message) {
    var config = window.TP_CONFIG || {};
    var phone = config.phone || '50621015631';
    var defaultMsg = config.generalMessage || 'Hola, me interesa cotizar autopartes. ¿Me pueden asesorar?';
    var encoded = encodeURIComponent(message || defaultMsg);
    return 'https://wa.me/' + phone + '?text=' + encoded;
  }

  function getProductWhatsAppURL(productName, categoryName) {
    var config = window.TP_CONFIG || {};
    var template = config.productTemplate || '';
    if (!template) {
      return getWhatsAppURL('Hola, me interesa cotizar: ' + productName);
    }
    var message = template
      .replace('{product_name}', productName)
      .replace('{category_name}', categoryName);
    return getWhatsAppURL(message);
  }

  /* ---------- Analytics tracking ---------- */
  function trackWhatsAppClick(section, productName) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'whatsapp_click', {
        section: section,
        product_name: productName || 'general'
      });
    }
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Contact', {
        content_name: productName || 'general',
        content_category: section
      });
    }
  }

  /* ---------- Init WhatsApp links ---------- */
  function initWhatsAppLinks() {
    var generalUrl = getWhatsAppURL();

    document.querySelectorAll('[data-tp-wa]').forEach(function(el) {
      el.href = generalUrl;
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    });

    document.querySelectorAll('[data-tp-wa-product]').forEach(function(el) {
      var product = el.getAttribute('data-tp-wa-product');
      var category = el.getAttribute('data-tp-wa-category') || '';
      el.href = getProductWhatsAppURL(product, category);
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    });

    document.querySelectorAll('[data-tp-wa], [data-tp-wa-product]').forEach(function(el) {
      el.addEventListener('click', function() {
        var section = el.getAttribute('data-tp-section') || 'unknown';
        var product = el.getAttribute('data-tp-wa-product') || '';
        trackWhatsAppClick(section, product);
      });
    });
  }

  /* ---------- Smooth Scroll ---------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function() {
    initWhatsAppLinks();
    initSmoothScroll();
  });

  // Re-init on Shopify section render (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initWhatsAppLinks();
    });
  }
})();
